import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import
{
    MAT_DIALOG_DATA,
    MatDialogModule,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

// Data interface for the confirm dialog
export interface ConfirmDialogData
{
    title?: string;
    message?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent
{
    constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) { }
}
